import React, { Component } from "react";
import dashboardIcon from "../../assets/frontPageIcons/dashboard-icon.png";
import feedbackIcon from "../../assets/frontPageIcons/feedback-icon.png";
import followUpIcon from "../../assets/frontPageIcons/follow-up-icon.png";
import notificationIcon from "../../assets/frontPageIcons/notification-icon.png";
import trackIssueIcon from "../../assets/frontPageIcons/track-issue-icon.png";
import { Image } from "react-bootstrap";
import Fade from "react-reveal/Fade";

class KeyEnablers extends Component {
  render() {
    return (
      <div className="key-enablers-wrapper" id="features">
        <div className="container">
          <h2>Key Features</h2>
          <Fade bottom>
            <ul className="key-enablers">
              <li>
                <div className="enablers-image">
                  <Image
                    src={dashboardIcon}
                    alt="Icon Dashboard"
                    loading="lazy"
                  />
                </div>
                <div className="enablers-content">
                  <h3>Dashboard</h3>
                  <p>
                    The PMG portal provides a summary of the projects and their
                    issues on a dashboard. All the relevant stakeholders will be
                    able to view the progress of the project and download
                    reports.
                  </p>
                </div>
              </li>
              <li>
                <div className="enablers-image">
                  <Image src={trackIssueIcon} alt="Icon Track" loading="lazy" />
                </div>
                <div className="enablers-content">
                  <h3>Track Issues Status</h3>
                  <p>
                    The PMG portal allows for real-time monitoring and status
                    updating in the issue resolution process. All the
                    stakeholders can track the issue resolution process across
                    stages.
                  </p>
                </div>
              </li>
              <li>
                <div className="enablers-image">
                  <Image
                    src={followUpIcon}
                    alt="Icon Meetings"
                    loading="lazy"
                  />
                </div>
                <div className="enablers-content">
                  <h3>Follow-Up</h3>
                  <p>
                    PMG conducts periodic meetings at the state and ministry
                    levels to identify bottlenecks in projects and understand
                    their status by engaging with all the stakeholders.
                  </p>
                </div>
              </li>
              <li>
                <div className="enablers-image">
                  <Image
                    src={feedbackIcon}
                    alt="Icon Feedback"
                    loading="lazy"
                  />
                </div>
                <div className="enablers-content">
                  <h3>Feedback</h3>
                  <p>
                    The PMG portal allows project proponents as well state and
                    ministry officials to provide feedback on the issue
                    resolution mechanism and can also offer comments on specific
                    issues.
                  </p>
                </div>
              </li>
              {/*<li>*/}
              {/*<div className="enablers-image bgcolor-orange">*/}
              {/*<Image src={ImagePragati} alt="Icon Pragati" />*/}
              {/*</div>*/}
              {/*<h3>PRAGATI</h3>*/}
              {/*<p>*/}
              {/*PMG also selects projects for PRAGATI review at the level of*/}
              {/*the Prime Minister on a monthly basis. These projects are*/}
              {/*selected on the basis of their criticality and value to the*/}
              {/*nation.*/}
              {/*</p>*/}
              {/*</li>*/}
              <li>
                <div className="enablers-image">
                  <Image
                    src={notificationIcon}
                    alt="Icon Notifications"
                    loading="lazy"
                  />
                </div>
                <div className="enablers-content">
                  <h3>Notifications</h3>
                  <p>
                    The PMG portal posts the latest notifications for the
                    stakeholders to have updated information on the project and
                    their issues.
                  </p>
                </div>
              </li>
            </ul>
          </Fade>
        </div>
      </div>
    );
  }
}

export default KeyEnablers;
